
import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';

import { iban } from './validator';

const VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => IbanValidatorDirective),
  multi: true
};

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[iban][formControlName],[iban][formControl],[iban][ngModel]',
  providers: [ VALIDATOR ]
})
export class IbanValidatorDirective implements Validator {
  validate(c: AbstractControl): {[key: string]: any} {
    return iban(c);
  }
}
